// extracted by mini-css-extract-plugin
module.exports = {"BottomLoader":"BottomLoader_BottomLoader__14HwH"};